import { apiGet } from './client.js';

export const getClients = () => apiGet('/clients');
export const getStores = (clientId) => clientId ? apiGet(`/clients/${clientId}/stores`) : apiGet('/stores');
export const getTerminals = (clientId) => clientId ? apiGet(`/clients/${clientId}/terminals`) : apiGet('/terminals');
